<template>
   
    <div v-if="!isMobile" class="">
    <CHeader :fixed="isFixedHeader" :with-subheader="false" light class="flex-flow-unset">
        <div class="cus-header-main">
            <div class="search-flight-wrapper w-100">
                <div class="wrapper">
                    <div class="logo" @click="navToDashBoard()">
                        <img class="" src="@imgPath/img/svg/logo/brand-white.svg" width="auto" height="43"
                             alt="CoreUI Logo">
                    </div>
                    <div class="menu">
                        <ul>
                            <li @click="navToDashBoard()"><span>{{$t('header.dashboard')}}</span></li>
                            <li  @click="navToMyBookingPage()"><span>{{$t('header.mybooking')}}</span></li>
                            <li  @click="navToTicketingPage()"><span>{{$t('header.ticktQue')}}</span></li>
<!--                            <li>Flight</li>-->
                        </ul>
                    </div>

                    <div class="d-flex h-search-wrap">
                        <!-- <div class="search">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512.005 512.005" style="enable-background:new 0 0 512.005 512.005;" xml:space="preserve">
<g>
	<g>
		<path d="M505.749,475.587l-145.6-145.6c28.203-34.837,45.184-79.104,45.184-127.317c0-111.744-90.923-202.667-202.667-202.667    S0,90.925,0,202.669s90.923,202.667,202.667,202.667c48.213,0,92.48-16.981,127.317-45.184l145.6,145.6    c4.16,4.16,9.621,6.251,15.083,6.251s10.923-2.091,15.083-6.251C514.091,497.411,514.091,483.928,505.749,475.587z     M202.667,362.669c-88.235,0-160-71.765-160-160s71.765-160,160-160s160,71.765,160,160S290.901,362.669,202.667,362.669z"/>
	</g>
</g>
                                <g>
</g>
                                <g>
</g>
                                <g>
</g>
                                <g>
</g>
                                <g>
</g>
                                <g>
</g>
                                <g>
</g>
                                <g>
</g>
                                <g>
</g>
                                <g>
</g>
                                <g>
</g>
                                <g>
</g>
                                <g>
</g>
                                <g>
</g>
                                <g>
</g>
</svg>
                              <input type="text" placeholder="Search">

                        </div> -->
                        <TheHeaderDropdownAccnt style="list-style: none;"/>

                    </div>
                </div>
            </div>
        </div>


        <CToggler 
                in-header
                class="ml-3 d-lg-none"
                v-c-emit-root-event:toggle-sidebar-mobile
        />
          

        <!-- <CToggler
          in-header
          class="ml-3 d-md-down-none"
          v-c-emit-root-event:toggle-sidebar
        /> -->
        <span class="brand-logo-center c-header-brand mx-auto d-lg-none">

        </span>
<!--        <img class="c-header-brand mx-auto d-lg-none" src="@/assets/az/img/svg/logo.svg" width="auto"-->
<!--             height="46" alt="CoreUI Logo">-->
        <!-- <CHeaderBrand
          class="mx-auto d-lg-none"
          src="~@assets/mf/img/svg/maing_fong.svg"
          width="97"
          height="46"
          alt="CoreUI Logo"
        /> -->
        <CHeaderNav class="d-md-down-none mr-auto">
            <!-- <CHeaderNavItem class="px-3">
              <CHeaderNavLink to="/dashboard">
                Dashboard
              </CHeaderNavLink>
            </CHeaderNavItem>
            <CHeaderNavItem class="px-3">
              <CHeaderNavLink to="/users" exact>
                Users
              </CHeaderNavLink>
            </CHeaderNavItem>
            <CHeaderNavItem class="px-3">
              <CHeaderNavLink>
                Settings
              </CHeaderNavLink>
            </CHeaderNavItem> -->
        </CHeaderNav>
        <!--  <CHeaderNav class="mr-4">
              <CHeaderNavItem class="d-md-down-none mx-2">
                  <cLanguagePicker
                          v-model="language"
                          ctrlName="en_name"
                          :isShowCode="true"
                          :isMultiple="false"
                          :isSearchable="true"
                          :url="languageListURL"
                          rules="_required"
                          :selValue="language"
                  />
              </CHeaderNavItem>
        <CHeaderNavItem class="d-md-down-none mx-2 btn-blue">-->
        <!--                <CButton @click="SIMULATE_JWT(true)">-->
        <!--                    <CIcon name="cil-star"/>-->
        <!--                </CButton>-->
        <!--            </CHeaderNavItem>-->
        <!-- <CHeaderNavItem class="d-md-down-none mx-2">
          <CHeaderNavLink>
            <CIcon name="cil-bell" />
          </CHeaderNavLink>
        </CHeaderNavItem>
        <CHeaderNavItem class="d-md-down-none mx-2">
          <CHeaderNavLink>
            <CIcon name="cil-list" />
          </CHeaderNavLink>
        </CHeaderNavItem>
        <CHeaderNavItem class="d-md-down-none mx-2">
          <CHeaderNavLink>
            <CIcon name="cil-envelope-open" />
          </CHeaderNavLink> -->
        <!-- </CHeaderNavItem> -->

        <!--            <TheHeaderDropdownAccnt/>-->
        <!--        </CHeaderNav>-->

        <!-- <div>
          <img
            class="round"
            width="60"
            height="60"
            :avatar="
              AgtSignInReq
                ? AgtSignInReq.emailid[0]
                : SystSignInReq
                ? SystSignInReq.emailid[0]
                : ''
            "
          />
        </div>
         <CSubheader class="px-3">
          <CBreadcrumbRouter class="border-0"/>
        </CSubheader> -->
    </CHeader>
</div>
<!-- <Header v-else-if="isMobile" :isFixedHeader="isFixedHeader"> </Header> -->
<!-- </div> -->
<aHeader v-else-if="isMobile" :isFixedHeader="isFixedHeader"> </aHeader>
</template>

<script>

    import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
    import cLanguagePicker from "../components/cLanguagePicker";
    import {mapActions, mapGetters} from "vuex";
    import SERVICE_URL from "../config/API_DATA";
    import {type} from "os";
    import router, { navigate, goBack } from "../router/index";
    import { PATHNAME } from "../util/constants.js";
    import { LOG_TYPE } from "../config/API_DATA";
    import BaseConfiguration from "../config/base";
    import Logger from "../services/logger";
    import Multiselect from "vue-multiselect";
    import store from "../store/index";
     if (BaseConfiguration.isMobile) {
  // var aHeader = require('./../mobile/components/aHeader').default;
  // import("./../mobile/components/aHeader");
} 
    export default {
        name: "TheHeader",
        components: {
            TheHeaderDropdownAccnt,
            cLanguagePicker,
            Multiselect,
            // aHeader
        },

        data() {
            return {
              isMobile: BaseConfiguration.isMobile,
                isFixedHeader: true,
                languageListURL: SERVICE_URL.LANGUAGE_LIST,
                language: [
                    {
                        langcode: null,
                        en_name: null,
                        native_name: null,
                    }
                ],
                menuList: [],
                selMenu: null
            };
        },
        mounted() {
            this.$root.$on("toggle-fixed-header", (isClose) => {
                if (isClose) {
                    this.isFixedHeader = false;
                } else {
                    this.isFixedHeader = true;
                }
            });
        },
        methods: {
           // ...mapActions("sSimulateJwt", {SIMULATE_JWT: "SIMULATE_JWT"}),

            navToDashBoard() {
               if(this.$route.path != PATHNAME.DASHBOARD){
                 navigate(PATHNAME.DASHBOARD);
               }
            },

            navToMyBookingPage() {
              if(this.$route.path != PATHNAME.MY_BOOKING){
                navigate(PATHNAME.MY_BOOKING);
              }
            },

            navToTicketingPage() {
              if(this.$route.path != PATHNAME.TICKETING_QUEUE){
                navigate(PATHNAME.TICKETING_QUEUE);
              }
            },

            onChangeMenu(pMenu) {
                try {
                  if(BaseConfiguration.isDebug) console.log("onChangeMenu");
                  //let retValue;
                  this.selMenu = pMenu;
                  let routing = null;
                  if(pMenu && pMenu.child && pMenu.child.length>0)
                    routing = pMenu.child[0].routing;
                  else if(pMenu && pMenu.routing)
                    routing = pMenu.routing;
                  if(routing && routing != this.$route.path){
                       navigate(routing);
                    }                           
                } catch (err) {
                        let body = Logger.buildRequest(
                          "TheHeader",
                          "error in onChangeMenu",
                          err.toString(),
                          "onChangeMenu",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  //return retValue;
                }, 

                // getMenus() {
                // try {
                //   if(BaseConfiguration.isDebug) console.log("getMenus");
                //    if(this.menuStoreRes){
                //       this.menuList = this.menuStoreRes;
                //    }            
                // } catch (err) {
                //         let body = Logger.buildRequest(
                //           "TheHeader",
                //           "error in getMenus",
                //           err.toString(),
                //           "getMenus",
                //           LOG_TYPE.ERROR
                //         );
                //         Logger.getResponse(body);
                //       }
                //   //return retValue;
                // }, 
        },
        computed: {
            ...mapGetters("sAgtLogin", {AgtSignInReq: "GET_SIGNIN_REQ"}),
            ...mapGetters("sSysLogin", {SystSignInReq: "GET_ADMIN_SIGNIN_REQ"}),
            ...mapGetters("sMenus", {menuStoreRes: "GET_ALL_MENUS_RES"})
           
        },

        watch: {
            menuStoreRes(val) {
                if (val) {
                    this.menuList = val;
                }
            }
        },

        /* created() {},
         beforeMount() {
           try {
             let avatarScript = document.createElement("script");
             console.log(JSON.stringify(avatarScript));
             avatarScript.setAttribute("src", "@/lib/avatar.js");
             avatarScript.setAttribute("type", "text/javascript");
             console.log(JSON.stringify(avatarScript));
             document.head.appendChild(avatarScript);
             console.log(JSON.stringify(avatarScript));
           } catch (e) {
             alert(e);
           }
         }*/
         created(){
           if(this.menuStoreRes){
             this.menuList = this.menuStoreRes;
           }
         }
    };
</script>

<style>
    .round {
        border-radius: 50%;
    }
</style>
